// extracted by mini-css-extract-plugin
module.exports = {"loginBodyContent":"style-module--loginBodyContent--1URb7"};